import React, { useEffect, useState } from "react";
import { IAutomation } from "../../interfaces/IAutomation";
import {
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { ITaskState } from "../../interfaces/ITaskState";
import { IAutomationCategory } from "../../interfaces/IAutomationCategory";
import { AutomationChangeStateEdit, getEmptyAutomationChangeState } from "./AutomationChangeStateEdit";
import { IOfferState } from "../../interfaces/IOfferState";
import { IProjectState } from "../../interfaces/IProjectState";
import { IBillState } from "../../interfaces/IBillState";
import { AutomationChangeStateRow } from "./AutomationChangeStateRow";

interface IProps {
    automation: IAutomation;
    setAutomation: Function;
    autoCategory: IAutomationCategory[];
    offerStateArray: IOfferState[];
    projectStateArray: IProjectState[];
    taskStateArray: ITaskState[];
    billStateArray: IBillState[];
}

export const AutomationChangeStateCard: React.FC<IProps> = ({
    automation,
    setAutomation,
    autoCategory,
    offerStateArray,
    projectStateArray,
    taskStateArray,
    billStateArray,
}) => {
    const [autoChangeStateArray, setAutoChangeStateArray] = useState(automation.AutomationChangeStateArray);
    //
    const [isOpenNew, setIsOpenNew] = useState(false);
    const [newAutoChangeState, setNewAutoChangeState] = useState(
        getEmptyAutomationChangeState(automation.AutomationChangeStateArray, automation.id),
    );

    const handleOnNew = () => {
        setNewAutoChangeState(getEmptyAutomationChangeState(automation.AutomationChangeStateArray, automation.id));
        setIsOpenNew(true);
    };
    const handleSave = () => {
        setAutoChangeStateArray([...autoChangeStateArray, newAutoChangeState]);
        setIsOpenNew(false);
    };

    useEffect(() => {
        setAutomation({
            ...automation,
            AutomationChangeStateArray: [...autoChangeStateArray],
        });
    }, [autoChangeStateArray]);

    return (
        <>
            {isOpenNew && (
                <Dialog open onClose={() => setIsOpenNew(false)} maxWidth="sm" fullWidth>
                    <DialogContent>
                        <AutomationChangeStateEdit
                            autoCategoryArray={autoCategory}
                            autoChangeState={newAutoChangeState}
                            billStateArray={billStateArray}
                            offerStateArray={offerStateArray}
                            projectStateArray={projectStateArray}
                            setAutoChangeState={setNewAutoChangeState}
                            taskStateArray={taskStateArray}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenNew(false)}>
                            Abbruch
                        </Button>
                        <Button variant="contained" onClick={handleSave}>
                            Übernehmen
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <Card variant="outlined">
                <CardContent>
                    <Typography>
                        Automatische Statusänderungen (kaskadisch)
                        <Button sx={{ float: "right" }} variant="outlined" onClick={handleOnNew}>
                            Hinzufügen
                        </Button>
                    </Typography>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Kategorie</TableCell>
                                <TableCell>Zu Status</TableCell>
                                <TableCell width={100}>Aktionen</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {automation.AutomationChangeStateArray.map((autoChangeState) => (
                                <AutomationChangeStateRow
                                    key={`auto-changestate-${autoChangeState.id}`}
                                    autoCategoryArray={autoCategory}
                                    autoChangeState={autoChangeState}
                                    setAutoChangeStateArray={setAutoChangeStateArray}
                                    autoChangeStateArray={autoChangeStateArray}
                                    billStateArray={billStateArray}
                                    offerStateArray={offerStateArray}
                                    projectStateArray={projectStateArray}
                                    taskStateArray={taskStateArray}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </>
    );
};
